export default __webpack_public_path__ + "static/media/KanipakamTempleThree.27622d54.png";